export const GENERIC_USER_ERROR_KEY = "errors.generic"
export const GENERIC_USER_ERROR_MESSAGE = "Oops, something went wrong. Please try again."

export const getGenericUserErrorMessage = (
  translate?: (key: string, fallback: string) => unknown
): string => {
  const translated = translate?.(GENERIC_USER_ERROR_KEY, GENERIC_USER_ERROR_MESSAGE)

  return typeof translated === "string" && translated.trim()
    ? translated
    : GENERIC_USER_ERROR_MESSAGE
}
